// var $window = $(window);
// var breakPoint = 768;
//
// var resizeFlag = false;
// var windowWidth = $window.width();
// var windowHeight = $window.height();

//anchorLink
// import {anchorLink} from "../include/module";
// anchorLink();

var _isSP;
var windowW       = $(window).width();

//preload
import {preload} from "../include/module";
preload();

//checkSP
import {checkSP} from "../include/module";
checkSP();

//bgAnime
import {bgAnime} from "../include/module";
bgAnime();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showTtl
import {showTtl} from "../include/module";
showTtl();

$(window).on('load' , function() {
  viewImg();
});

const viewImg = () => {
  const img = document.getElementById('chartImg');
  const viewer = new Viewer(img, {
    backdrop: true, //背景オーバーレイの表示
    button: true, //閉じるボタンの表示
    navbar: false, //画像のサムネイルの表示
    title: false, //画像のタイトルの表示
    toolbar: true, //拡大・縮小などの操作ボタンの表示
    // className: 'img-popup', //ビューワーへ任意のclass名を付与
    // container: '#wrapper', //ビューワーの生成位置。デフォルトはbody直下
    fullscreen: true, //全画面表示を可能にするかどうか
    keyboard: true, //キーボードによる操作を有効に
    movable: true, //画像の移動可能にするかどうか
    zoomable: true, //画像の拡大・縮小を可能にするかどうか
    rotatable: false, //画像の回転を可能にするかどうか
    toggleOnDblclick: false, //ダブルクリックで等倍の操作を有効にするかどうか
    tooltip: true, //拡大率・縮小率の表示
    transition: true, //ポップアップ時のアニメーション有無
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      oneToOne: 1,
      reset: 1,
      rotateLeft: 0,
      rotateRight: 0,
      flipHorizontal: 0,
      flipVertical: 0,
    },
  });

};



// WEBPACK FOOTER //
// ./src/bangdream_3rd_v0/assets/js/chart/script.js